module.exports = __webpack_public_path__ + "static/MOD2-7761bf29ca02fe8c5a9c8e9e2dc5c0d2.jpg";